export const invitePopupEn = {
  inviteToCompany: 'Invitation to the company',
  submitButton: 'Add',
  addingVirtualUser: 'Adding virtual user',
  emailList: 'E-mail addresses:',
  emailAddress: 'E-mail address:',
  roleInCompany: 'Role in company:',
  inputPlaceholderShort: 'Enter email addresses',
  inviteInProjects: 'Also invite to projects:',
  addToProjects: 'Also add to projects:',
  inputPlaceholderLong:
    'Enter email addresses, for example, user1@mail.ru, user2@mail.ru',
  inviteUsersButton: 'Invite employees',
  noProjects: "You don't have any projects yet",
  error1:
    'Some e-mails are not recognized, they are all at the top of the list for convenience',
  error2: (max: number, excess: number) =>
    `You cannot invite more than ${max} people in your tariff. You are missing ${excess} seats`,
  error3: 'The user has already been invited, we will send a second invitation',
  inviteCaption: 'Invite employees to the project',
  inviteButton: 'Invite',
  roleForInvitees: 'Role for invitees:',
  emailAlreadyCreated: 'The role has already been created',
  cannotCreateRole: 'Cannot create role',
  roleCreated: 'Role created',
  userCardCaption: 'The user role corresponds to the employee:'
}

export const invitePopupRu: typeof invitePopupEn = {
  inviteToCompany: 'Приглашение в компанию',
  addingVirtualUser: 'Добавление виртуального сотрудника',
  submitButton: 'Добавить',
  emailList: 'E-mail адреса:',
  emailAddress: 'E-mail адрес:',
  roleInCompany: 'Роль в компании',
  inviteInProjects: 'Также пригласить в проекты:',
  addToProjects: 'Также добавить в проекты:',
  inputPlaceholderShort: 'Введите адреса электронной почты',
  inputPlaceholderLong:
    'Введите адреса электронной почты, например, user1@mail.ru, user2@mail.ru',
  inviteUsersButton: 'Пригласить сотрудников',
  noProjects: 'У вас пока нет ни одного проекта',
  error1:
    'Некоторые e-mail не распознаны, все они в начале списка для удобства',
  error2: (max: number, excess: number) =>
    `В вашем тарифе нельзя пригласить больше ${max} человек. Вам не хватает ${excess} мест`,
  error3: 'Пользователь уже приглашен, вышлем повторное приглашение',
  inviteCaption: 'Пригласите сотрудников в проект',
  inviteButton: 'Пригласить',
  roleForInvitees: 'Роль для приглашаемых:',
  emailAlreadyCreated: 'Роль уже создана',
  cannotCreateRole: 'Не удалось создать роль',
  roleCreated: 'Роль создана',
  userCardCaption: 'Роль пользователя соответствует сотруднику:'
}
